'use strict';exports.__esModule = true;exports.updateSubscriptionsTopics = exports.loadSubscriptionsTopics = exports.resetSubscriptionState = exports.unsubscribeFromTopicByPhone = exports.unsubscribeFromTopic = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);
var _axiosConfig = require('../../helpers/axiosConfig');
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var unsubscribeFromTopic = (0, _reduxAct.createAction)('/UNSUBSCRIBE_FROM_TOPIC');
var unsubscribeFromTopicSuccess = (0, _reduxAct.createAction)('/UNSUBSCRIBE_FROM_TOPIC_SUCCESS');
var unsubscribeFromTopicFail = (0, _reduxAct.createAction)('/UNSUBSCRIBE_FROM_TOPIC_FAIL');

var unsubscribeFromTopicByPhone = (0, _reduxAct.createAction)('/UNSUBSCRIBE_FROM_TOPIC_BY_PHONE');
var unsubscribeFromTopicByPhoneSuccess = (0, _reduxAct.createAction)('/UNSUBSCRIBE_FROM_TOPIC_BY_PHONE_SUCCESS');
var unsubscribeFromTopicByPhoneFail = (0, _reduxAct.createAction)('/UNSUBSCRIBE_FROM_TOPIC_BY_PHONE_FAIL');

var loadSubscriptionsTopics = (0, _reduxAct.createAction)('/LOAD_SUBSCRIPTIONS_TOPICS');
var loadSubscriptionsTopicsSuccess = (0, _reduxAct.createAction)('/LOAD_SUBSCRIPTIONS_TOPICS_SUCCESS');
var loadSubscriptionsTopicsFail = (0, _reduxAct.createAction)('/LOAD_SUBSCRIPTIONS_TOPICS_FAIL');

var updateSubscriptionsTopics = (0, _reduxAct.createAction)('/UPDATE_SUBSCRIPTIONS_TOPICS');
var updateSubscriptionsTopicsSuccess = (0, _reduxAct.createAction)('/UPDATE_SUBSCRIPTIONS_TOPICS_SUCCESS');
var updateSubscriptionsTopicsFail = (0, _reduxAct.createAction)('/UPDATE_SUBSCRIPTIONS_TOPICS_FAIL');

var resetSubscriptionState = (0, _reduxAct.createAction)('/RESET_SUBSCRIPTION_STATE');

var initialState = {
  sending: false,
  sent: false,
  error: null,
  loading: false,
  loaded: false,
  updating: false,
  updated: false,
  topics: null };


var sendHandlerSuccess = function sendHandlerSuccess(state, action) {
  if (action.status === 200 && !Object.keys(action.data).length) {
    return {
      sending: false,
      sent: false,
      error: { message: 'User not found', status: 404 } };

  }

  return Object.assign({},
  state, {
    sending: false,
    sent: true });

};

var sendHandlerFail = function sendHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while unsubscription');
  return Object.assign({},
  state, {
    sending: false,
    sent: false,
    error: error });

};

var sendRequest = function sendRequest(_ref) {var topic_id = _ref.topic_id,user_id = _ref.user_id;return (
    _axiosConfig.axiosMailingInstance.post('/subscribers/' + user_id + '/unsubscribe', { topic_id: topic_id }).
    then(unsubscribeFromTopicSuccess, unsubscribeFromTopicFail));};

var sendPhoneRequest = function sendPhoneRequest(_ref2) {var topic_id = _ref2.topic_id,phone = _ref2.phone;return (
    _axiosConfig.axiosMailingInstance.post('/subscribers/unsubscribe_phone', { topic_id: topic_id, phone: phone }).
    then(unsubscribeFromTopicSuccess, unsubscribeFromTopicFail));};

var fetchLoad = function fetchLoad(_ref3) {var access_token = _ref3.access_token,isAgent = _ref3.isAgent;return (
    _axiosConfig.axiosMailingInstance.get('/subscribers/subscriptions', { params: { is_realtor: isAgent }, headers: { access_token: access_token } }).
    then(loadSubscriptionsTopicsSuccess, loadSubscriptionsTopicsFail));};

var sendUpdateTopics = function sendUpdateTopics(_ref4) {var access_token = _ref4.access_token,topics_ids = _ref4.topics_ids,enable = _ref4.enable,is_realtor = _ref4.is_realtor;return (
    _axiosConfig.axiosMailingInstance.post('/subscribers/subscriptions', { topics_ids: topics_ids, enable: enable, is_realtor: is_realtor }, { headers: { access_token: access_token } }).
    then(updateSubscriptionsTopicsSuccess, updateSubscriptionsTopicsFail));};

var sendHandler = function sendHandler(state, data) {return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { error: null, sending: true }), promise(sendRequest, data)));};
var sendPhoneHandler = function sendPhoneHandler(state, data) {return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { error: null, sending: true }), promise(sendPhoneRequest, data)));};

var handleReset = function handleReset() {return Object.assign({}, initialState);};

var handleLoadSubscriptionsTopics = function handleLoadSubscriptionsTopics(state, params) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchLoad, params));};

var handleLoadSubscriptionsTopicsSuccess = function handleLoadSubscriptionsTopicsSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    topics: action.data });};


var handleLoadSubscriptionsTopicsFail = function handleLoadSubscriptionsTopicsFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while loading subscriptions topics');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    topics: null,
    error: error });

};

var handleUpdateSubscriptionsTopics = function handleUpdateSubscriptionsTopics(state, params) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    updating: true,
    error: null }),
  promise(sendUpdateTopics, params));};

var handleUpdateSubscriptionsTopicsSuccess = function handleUpdateSubscriptionsTopicsSuccess(state, action) {return Object.assign({},
  state, {
    updating: false,
    updated: true,
    topics: action.data });};


var handleUpdateSubscriptionsTopicsFail = function handleUpdateSubscriptionsTopicsFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Error while updating subscriptions topics');

  return Object.assign({},
  state, {
    updating: false,
    updated: false,
    topics: null,
    error: error });

};


var subscriptions = (0, _reduxAct.createReducer)(function (on) {
  on(unsubscribeFromTopic, sendHandler);
  on(unsubscribeFromTopicSuccess, sendHandlerSuccess);
  on(unsubscribeFromTopicFail, sendHandlerFail);
  on(unsubscribeFromTopicByPhone, sendPhoneHandler);
  on(unsubscribeFromTopicByPhoneSuccess, sendHandlerSuccess);
  on(unsubscribeFromTopicByPhoneFail, sendHandlerFail);
  on(resetSubscriptionState, handleReset);
  on(loadSubscriptionsTopics, handleLoadSubscriptionsTopics);
  on(loadSubscriptionsTopicsSuccess, handleLoadSubscriptionsTopicsSuccess);
  on(loadSubscriptionsTopicsFail, handleLoadSubscriptionsTopicsFail);
  on(updateSubscriptionsTopics, handleUpdateSubscriptionsTopics);
  on(updateSubscriptionsTopicsSuccess, handleUpdateSubscriptionsTopicsSuccess);
  on(updateSubscriptionsTopicsFail, handleUpdateSubscriptionsTopicsFail);
}, initialState);exports.


unsubscribeFromTopic = unsubscribeFromTopic;exports.
unsubscribeFromTopicByPhone = unsubscribeFromTopicByPhone;exports.
resetSubscriptionState = resetSubscriptionState;exports.
loadSubscriptionsTopics = loadSubscriptionsTopics;exports.
updateSubscriptionsTopics = updateSubscriptionsTopics;exports.default =


subscriptions;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/subscriptions.js
// module id = 399
// module chunks = 0